module.exports = __webpack_public_path__ + "static/media/simulacao_mobile.ed2ad09b.jpg";